// utils/versamentoUtils.ts

import { collection, getDocs, query, QueryConstraint, where } from "firebase/firestore";
import { db } from "../../firebase";
import { DocumentSnapshot } from "firebase/firestore";
import { toRate, toRatePagata, toRateRiscaldamento, toRateRiscaldamentoPagata } from "../../services/converters/firestoreConverters";

// --- Generic helper that takes arbitrary query constraints ---
async function fetchAndConvertQuery<T>(
  condominioId: string,
  subcol: string,
  converter: (doc: DocumentSnapshot) => T,
  ...constraints: QueryConstraint[]
): Promise<T[]> {
  const q = query(
    collection(db, "condomini", condominioId, subcol),
    ...constraints
  );
  const snap = await getDocs(q);
  return snap.docs.map(converter);
}


export async function computeNextNumPrevAndNumRata(
  condominioId: string,
  feeType: 'GO' | 'GS' | 'RISC',
  ownerCode?: string,
  unitCode?: string
): Promise<{ num_prev: number; num_rata: number }> {
  if (feeType === 'GO' || feeType === 'GS') {
    const tipoVers = feeType === 'GO' ? 'VO' : 'VS';
    const ordinaryTransactions = await fetchAndConvertQuery(
      condominioId,
      'rate_pagate',
      toRatePagata,
      where('cod_condomino', '==', ownerCode!)
    );
    const maxPaid = ordinaryTransactions
      .filter(r => r.tipo_rata === tipoVers)
      .reduce((m, r) => Math.max(m, r.num_rata), 0);

    const ordinaryScheduled = await fetchAndConvertQuery(
      condominioId,
      'rate',
      toRate,
      where('cod_condomino', '==', ownerCode!)
    );
    const prevSet = new Set<number>();
    ordinaryScheduled
      .filter(r => r.tipo_rata === feeType)
      .forEach(r => prevSet.add(r.num_prev));
    return {
      num_prev: Math.max(0, ...prevSet),
      num_rata: maxPaid + 1,
    };
  } else {
    const heatingTransactions = await fetchAndConvertQuery(
      condominioId,
      'rate_pagate_riscaldamento',
      toRateRiscaldamentoPagata,
      where('cod_ui', '==', unitCode!)
    );
    const maxPaid = heatingTransactions.reduce((m, r) => Math.max(m, r.num_rata), 0);

    const heatingScheduled = await fetchAndConvertQuery(
      condominioId,
      'rate_riscaldamento',
      toRateRiscaldamento,
      where('cod_ui', '==', unitCode!)
    );
    const prevSet = new Set<number>();
    heatingScheduled.forEach(r => prevSet.add(r.num_prev));

    return {
      num_prev: Math.max(0, ...prevSet),
      num_rata: maxPaid + 1,
    };
  }
}
